var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from "classnames";
import { useField, useFormikContext } from "formik";
import React from "react";
import { FormatTypeImageOrientation } from "../../../modules/generator/forms/format-form/format-form-enums";
import { getTooltipText } from "../../../modules/generator/generator-tooltips";
export var FormItemFormat = function (_a) {
    var name = _a.name, options = _a.options, tooltips = _a.tooltips, program = _a.program, onChange = _a.onChange;
    var setFieldValue = useFormikContext().setFieldValue;
    var _b = __read(useField(name), 2), field = _b[0], meta = _b[1];
    var selectedValue = field.value;
    var handleChange = function (value) {
        onChange(value);
        setFieldValue(name, value);
    };
    return (React.createElement("div", { className: "form-item-format" },
        React.createElement("div", { className: "form-item-format__item_groups" }, options.map(function (_a) {
            var formats = _a.formats;
            return (React.createElement("div", { className: "form-item-format__items" }, formats.map(function (_a) {
                var name = _a.name, size = _a.size, formatTypes = _a.formatTypes, tooltipKey = _a.tooltipKey;
                return (React.createElement("div", { className: "form-item-format__item" },
                    React.createElement("div", { className: "form-item-format__heading_box" },
                        React.createElement("div", { className: "form-item-format__heading" }, name),
                        getTooltipText(tooltips.tooltips, tooltipKey, program) ? (React.createElement("div", { className: "form-item-format__tooltip" },
                            "i",
                            React.createElement("div", { className: "form-item-format__tooltip_window tooltip" }, getTooltipText(tooltips.tooltips, tooltipKey, program)))) : (React.createElement(React.Fragment, null))),
                    React.createElement("div", { className: "form-item-format__perex" }, size),
                    React.createElement("div", { className: "form-item-format__formats" }, formatTypes.map(function (_a) {
                        var name = _a.name, value = _a.value, image = _a.image, ImageComponent = _a.ImageComponent, imageOrientation = _a.imageOrientation;
                        return (React.createElement("div", { className: classNames("form-item-format__format", {
                                "form-item-format__format--selected": value === selectedValue,
                            }), onClick: function () { return handleChange(value); } },
                            React.createElement("div", { className: "form-item-format__title_box" },
                                React.createElement("div", { className: "form-item-format__title" }, name),
                                getTooltipText(tooltips.tooltips, value, program) ? (React.createElement("div", { className: "form-item-format__tooltip" },
                                    "i",
                                    React.createElement("div", { className: "form-item-format__tooltip_window tooltip" }, getTooltipText(tooltips.tooltips, value, program)))) : (React.createElement(React.Fragment, null))),
                            React.createElement(ImageComponent, { className: classNames("form-item-format__image", {
                                    "form-item-format__image--landscape": imageOrientation ===
                                        FormatTypeImageOrientation.Landscape,
                                    "form-item-format__image--portrait": imageOrientation ===
                                        FormatTypeImageOrientation.Portrait,
                                }) })));
                    }))));
            })));
        }))));
};
